// Generate 20 product
import itemsData from "./image-data.json";

const items = itemsData.map((item) => {
  try {
    const mappedIed = {
      ...item,
      imagePath: require(`./assets/products/${item.imagePath}`), // Adjust the image file format if needed
    };
    return mappedIed
  } catch (error) {
    console.warn(error)
    return null
  }
}).filter((item) => item != null);

export { items };
